/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from 'react';
import { format } from 'date-fns';

// import icon from '../../assets/img/logo-footer.svg';
import icon from '../../assets/img/TotalEnergies_Logo_RGB.png';

import './PdfPage.scss';

interface IPdfPage {
  children: any;
  isHidden?: boolean;
}

export default function PdfPage({ isHidden, children }: IPdfPage): JSX.Element {
  return (
    <div className="PdfPage">
      {isHidden ? null : (
        <div className="page-stamp">
          <img src={icon} alt="total-icon" />
          <p className="">{format(new Date(), 'd MMMM yyyy')}</p>
        </div>
      )}
      <div className="page-content">{children}</div>
    </div>
  );
}

PdfPage.defaultProps = {
  isHidden: false,
};
